import { useContext } from 'react'

import { UserContext } from '../contexts'

export const useUserContext = () => {
  const context = useContext(UserContext)
  return { ...context }
}
